// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"687":"02aed27a","787":"9c2398b9","960":"61047a04"}[chunkId] + ".chunk.js";
};